export enum ReimbursementTypes {
    OutOfPocket = 'out-of-pocket',
    Stipend = 'stipend',
}
